"use client"
import { Utils } from "@/libs/Utils";
import clsx from "clsx";
import React from "react";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import "./styles.css";

interface LayoutFormProps {
    title?: string
    callback: any
    submited: boolean
    locale: string
    className?: string
    updateSubmited: any,
    children: React.ReactNode
}

const LayoutForm: React.FunctionComponent<LayoutFormProps> = ({
    title, children, callback, submited, locale = "en-US", className, updateSubmited }) => {

    const [success, setSuccess] = React.useState<boolean>(false)

    const formRef = React.useRef() as any
    const recaptchaRef = React.useRef() as any;

    const t = new Utils(locale).Translation
    const [loading, setLoading] = React.useState<boolean>(true);


    const [validated, setValidated] = React.useState<boolean>(false);
    const [capcha, setCapcha] = React.useState<string | undefined>(undefined);

    const handleSubmit = async (event: any) => {
        if (!!success) { setSuccess(false) }
        [
            event.preventDefault(),
            event.stopPropagation()
        ]
        setValidated(true)
        if (!event.currentTarget.checkValidity()) {
            return null
        } else {
            updateSubmited(true)
            const status = await callback(event.target.elements)
            try {
                recaptchaRef.current?.reset()
            } catch (error: any) {
                console.log(error?.message)
            }
            console.log(`response status`, status, typeof status)
            if (status === 200 || status === "200") {
                console.log('running here', formRef.current)
                try {
                    formRef.current?.reset()
                    setValidated(false)
                    setSuccess(true)
                } catch (error: any) {
                    console.log(error?.message)
                }
            }
            return updateSubmited(false)
        }
    }

    const onReCAPTCHAChange = (captchaCode: any) => {
        // If the reCAPTCHA code is null or undefined indicating that
        // the reCAPTCHA was expired then return early
        if (!captchaCode) {
            return;
        }

        // Else reCAPTCHA was executed successfully so proceed with the
        setCapcha(captchaCode)
    }
    React.useEffect(() => setLoading(false), [])


    return (
        <>
            <Form ref={formRef} noValidate validated={validated} className={clsx(className, submited ? 'submited' : '')} onSubmit={handleSubmit}>
                <>
                    {success && (
                        <Alert variant="success">{t("form.submit.success")}</Alert>
                    )}
                    {!!title && <h2 className="text-center">{title}</h2>}
                    <Row>
                        <Form.Group as={Col} md={6} xs={12} className="mb-3">
                            <Form.Label>{t("form.firstname")} <span className="text-danger">*</span></Form.Label>
                            <Form.Control required maxLength={60} name="firstname" type="text" />
                            <Form.Control.Feedback type="invalid">[{t("form.firstname")}] {t("required.message")}</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md={6} xs={12} className="mb-3">
                            <Form.Label>{t("form.lastname")}</Form.Label>
                            <Form.Control type="text" name="lastname" />
                        </Form.Group>
                        <Form.Group as={Col} md={12} xs={12} className="mb-3">
                            <Form.Label>{t("form.email")} <span className="text-danger">*</span></Form.Label>
                            <Form.Control required type="email" name="email" placeholder="name@example.com" />
                            <Form.Control.Feedback type="invalid">[{t("form.email")}] {t("required.message")}</Form.Control.Feedback>
                        </Form.Group>
                    </Row>
                    {children}
                    <Row>
                        {process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY && !loading && <Form.Group as={Col} md={12} xs={12} className="mt-3">
                            <div className="captcha" style={{
                                transform: "scale(0.85)",
                                transformOrigin: "0 0",
                            }}>
                                <ReCAPTCHA ref={recaptchaRef} hl={locale} sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY} onChange={onReCAPTCHAChange} />
                                <Form.Control required name="capcha" type="text" value={capcha} style={{ width: 0, height: 0, padding: 0, border: 'transparent' }} />
                                <Form.Control.Feedback type="invalid">[{t("form.capcha")}] {t("required.message")}</Form.Control.Feedback>
                            </div>
                        </Form.Group>}
                    </Row>
                    <Row>
                        <Col md={12} xs={12} className="mb-3 small">
                            <Form.Group >
                                <Form.Check type="checkbox" required label={t("submit.message")} />
                            </Form.Group>
                        </Col>
                        <Col md={12} xs={12} className="d-flex justify-content-center mt-3">
                            <Button
                                className={clsx("btn w-100 btn-small fw-semi-bold btn-gradient-orange btn-primary mx-auto")}
                                variant="primary" disabled={submited} type="submit"
                            >
                                {t("submit.button")}
                            </Button>
                        </Col>
                    </Row>
                </>
            </Form>
        </>
    )
}

export default LayoutForm